
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reactivate-listings",
      function () {
        return require("private-next-pages/reactivate-listings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reactivate-listings"])
      });
    }
  